export default {
    root: {
        class: [
            // Alignment
            'flex items-center',
            'gap-2',
            '[&_[data-pc-name=pcinputtext]]:w-12 [&_[data-pc-name=pcinputtext]]:text-center [&_[data-pc-name=pcinputtext]]:rounded [&_[data-pc-name=pcinputtext]]:border-gray-300',
        ],
    },
};
